export default __webpack_public_path__ + "8e4f361879e97022e85a145d2dd46a27.png";